import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from '@mui/material';
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import styles from '../QuoteTable/QuoteTable.module.scss';
import { useTranslation } from 'react-i18next';

const QuoteDenyAlert = ({ isOpen, handleCancel, handleSubmit, deniedItems, isSubmitted }) => {
  const { t } = useTranslation();

  return (<div data-testid="QuoteDenyAlert">
    <Dialog open={isOpen} onClose={handleCancel}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "400px",
          },
        },
      }}
    >
      <DialogTitle className={styles.commonDialogTitle}>
        <div className={styles.dialogTitleContainer}>
          <span className={styles.commonFexContainer}>{t("Quote.denyQuote")}</span>
          <IconButton
            className={styles.cancelIcon}
            onClick={handleCancel}
            aria-label="close"
            data-testid="closeAddSupportPin"
          >
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={`${styles.paddedBox} ${styles.marginTop20px}`}>
        <p className={styles.dialogDescription}>
          <span>{t("Quote.denyThisQuoteAlertMessage")}</span>
        </p>
        <p className={`${styles.dialogDescription} ${styles.underLineItem} ${styles.marginTop20px}`}>
          <span>{t("Quote.itemsDenied")}</span>
        </p>
        {deniedItems?.map((item, index) => (
          <p key={index} className={`${styles.dialogDescription} marginTopEight`}>
            <span className={styles.inlineFlexCenterGap}>
              {item?.description} <CloseIcon fontSize="small" /> {item?.quantity}
            </span>
          </p>
        ))}
      </DialogContent>
      <DialogActions className='alertButton'>
        <Button
          onClick={handleCancel}
          color='secondary'
          size="small">
          {t("Prescriptions.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={isSubmitted}
          data-testid="confirmButton"
          color='error'
          size="small">
          {t("Quote.denyItems")}
        </Button>
      </DialogActions>
    </Dialog>
  </div>)
}

export default QuoteDenyAlert;